import React, { useEffect, useState } from "react";

const THEME_STORAGE_KEY = "soma-ui-theme";

const getStoredTheme = () => {
    if (typeof window === "undefined") {
        return "light";
    }

    return window.localStorage.getItem(THEME_STORAGE_KEY) === "dark" ? "dark" : "light";
};

const applyTheme = (theme) => {
    document.documentElement.setAttribute("data-theme", theme);
    document.body?.setAttribute("data-theme", theme);
};

const ThemeToggle = ({ compact = false }) => {
    const [theme, setTheme] = useState(getStoredTheme);
    const isDark = theme === "dark";

    useEffect(() => {
        applyTheme(theme);
        window.localStorage.setItem(THEME_STORAGE_KEY, theme);
    }, [theme]);

    const toggleTheme = () => {
        setTheme((current) => (current === "dark" ? "light" : "dark"));
    };

    return (
        <button
            type="button"
            className={`theme-toggle ${compact ? "theme-toggle-compact" : ""}`}
            onClick={toggleTheme}
            aria-label={isDark ? "Passer en mode clair" : "Passer en mode sombre"}
            title={isDark ? "Mode clair" : "Mode sombre"}
        >
            <i className={`bx ${isDark ? "bx-sun" : "bx-moon"}`}></i>
            {!compact && <span>{isDark ? "Clair" : "Sombre"}</span>}
        </button>
    );
};

export default ThemeToggle;
